var _defs, _g, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefractotype1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .red-stroke {\n        fill: #e82b00;\n      }\n\n      .green-stroke {\n        fill: #50b050;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m364.36,364.09h-216.72v-216.72h216.72v216.72Zm-205.88-10.84h195.05v-195.05h-195.05v195.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "red-stroke",
    y: 249.77,
    width: 512,
    height: 12.46,
    transform: "translate(0 512) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "green-stroke",
    y: 297.45,
    width: 512,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "green-stroke",
    y: 206.43,
    width: 512,
    height: 12.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m207.1,273.07c-9.56,0-17.34-7.78-17.34-17.34s7.78-17.34,17.34-17.34,17.34,7.78,17.34,17.34-7.78,17.34-17.34,17.34Zm0-26.01c-4.78,0-8.67,3.89-8.67,8.67s3.89,8.67,8.67,8.67,8.67-3.89,8.67-8.67-3.89-8.67-8.67-8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m298.12,273.07c-9.56,0-17.34-7.78-17.34-17.34s7.78-17.34,17.34-17.34,17.34,7.78,17.34,17.34-7.78,17.34-17.34,17.34Zm0-26.01c-4.78,0-8.67,3.89-8.67,8.67s3.89,8.67,8.67,8.67,8.67-3.89,8.67-8.67-3.89-8.67-8.67-8.67Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 203.21,
    y: 229.23,
    width: 7.79,
    height: 53
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 294.23,
    y: 229.23,
    width: 7.79,
    height: 53
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefractotype1);
export default __webpack_public_path__ + "static/media/refractotype1.83168e4c27047aeca6564f258cf7ee03.svg";
export { ForwardRef as ReactComponent };